/* tslint:disable */
/* eslint-disable */
/**
 * Kubernetes
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: unversioned
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { IoK8sApiAuthenticationV1TokenRequestFromJSON, IoK8sApiAuthenticationV1TokenRequestToJSON, IoK8sApiAutoscalingV1ScaleFromJSON, IoK8sApiAutoscalingV1ScaleToJSON, IoK8sApiCoreV1BindingFromJSON, IoK8sApiCoreV1BindingToJSON, IoK8sApiCoreV1ComponentStatusFromJSON, IoK8sApiCoreV1ComponentStatusListFromJSON, IoK8sApiCoreV1ConfigMapFromJSON, IoK8sApiCoreV1ConfigMapToJSON, IoK8sApiCoreV1ConfigMapListFromJSON, IoK8sApiCoreV1EndpointsFromJSON, IoK8sApiCoreV1EndpointsToJSON, IoK8sApiCoreV1EndpointsListFromJSON, IoK8sApiCoreV1EventFromJSON, IoK8sApiCoreV1EventToJSON, IoK8sApiCoreV1EventListFromJSON, IoK8sApiCoreV1LimitRangeFromJSON, IoK8sApiCoreV1LimitRangeToJSON, IoK8sApiCoreV1LimitRangeListFromJSON, IoK8sApiCoreV1NamespaceFromJSON, IoK8sApiCoreV1NamespaceToJSON, IoK8sApiCoreV1NamespaceListFromJSON, IoK8sApiCoreV1NodeFromJSON, IoK8sApiCoreV1NodeToJSON, IoK8sApiCoreV1NodeListFromJSON, IoK8sApiCoreV1PersistentVolumeFromJSON, IoK8sApiCoreV1PersistentVolumeToJSON, IoK8sApiCoreV1PersistentVolumeClaimFromJSON, IoK8sApiCoreV1PersistentVolumeClaimToJSON, IoK8sApiCoreV1PersistentVolumeClaimListFromJSON, IoK8sApiCoreV1PersistentVolumeListFromJSON, IoK8sApiCoreV1PodFromJSON, IoK8sApiCoreV1PodToJSON, IoK8sApiCoreV1PodListFromJSON, IoK8sApiCoreV1PodTemplateFromJSON, IoK8sApiCoreV1PodTemplateToJSON, IoK8sApiCoreV1PodTemplateListFromJSON, IoK8sApiCoreV1ReplicationControllerFromJSON, IoK8sApiCoreV1ReplicationControllerToJSON, IoK8sApiCoreV1ReplicationControllerListFromJSON, IoK8sApiCoreV1ResourceQuotaFromJSON, IoK8sApiCoreV1ResourceQuotaToJSON, IoK8sApiCoreV1ResourceQuotaListFromJSON, IoK8sApiCoreV1SecretFromJSON, IoK8sApiCoreV1SecretToJSON, IoK8sApiCoreV1SecretListFromJSON, IoK8sApiCoreV1ServiceFromJSON, IoK8sApiCoreV1ServiceToJSON, IoK8sApiCoreV1ServiceAccountFromJSON, IoK8sApiCoreV1ServiceAccountToJSON, IoK8sApiCoreV1ServiceAccountListFromJSON, IoK8sApiCoreV1ServiceListFromJSON, IoK8sApiPolicyV1EvictionFromJSON, IoK8sApiPolicyV1EvictionToJSON, IoK8sApimachineryPkgApisMetaV1APIResourceListFromJSON, IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON, IoK8sApimachineryPkgApisMetaV1StatusFromJSON, IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON, } from '../models/index';
/**
 *
 */
export class CoreV1Api extends runtime.BaseAPI {
    /**
     * connect DELETE requests to proxy of Pod
     */
    async connectCoreV1DeleteNamespacedPodProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1DeleteNamespacedPodProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1DeleteNamespacedPodProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect DELETE requests to proxy of Pod
     */
    async connectCoreV1DeleteNamespacedPodProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1DeleteNamespacedPodProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect DELETE requests to proxy of Pod
     */
    async connectCoreV1DeleteNamespacedPodProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1DeleteNamespacedPodProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1DeleteNamespacedPodProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1DeleteNamespacedPodProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect DELETE requests to proxy of Pod
     */
    async connectCoreV1DeleteNamespacedPodProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1DeleteNamespacedPodProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect DELETE requests to proxy of Service
     */
    async connectCoreV1DeleteNamespacedServiceProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1DeleteNamespacedServiceProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1DeleteNamespacedServiceProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect DELETE requests to proxy of Service
     */
    async connectCoreV1DeleteNamespacedServiceProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1DeleteNamespacedServiceProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect DELETE requests to proxy of Service
     */
    async connectCoreV1DeleteNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1DeleteNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1DeleteNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1DeleteNamespacedServiceProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect DELETE requests to proxy of Service
     */
    async connectCoreV1DeleteNamespacedServiceProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1DeleteNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect DELETE requests to proxy of Node
     */
    async connectCoreV1DeleteNodeProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1DeleteNodeProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect DELETE requests to proxy of Node
     */
    async connectCoreV1DeleteNodeProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1DeleteNodeProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect DELETE requests to proxy of Node
     */
    async connectCoreV1DeleteNodeProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1DeleteNodeProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1DeleteNodeProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect DELETE requests to proxy of Node
     */
    async connectCoreV1DeleteNodeProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1DeleteNodeProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect GET requests to attach of Pod
     */
    async connectCoreV1GetNamespacedPodAttachRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1GetNamespacedPodAttach.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1GetNamespacedPodAttach.');
        }
        const queryParameters = {};
        if (requestParameters.container !== undefined) {
            queryParameters['container'] = requestParameters.container;
        }
        if (requestParameters.stderr !== undefined) {
            queryParameters['stderr'] = requestParameters.stderr;
        }
        if (requestParameters.stdin !== undefined) {
            queryParameters['stdin'] = requestParameters.stdin;
        }
        if (requestParameters.stdout !== undefined) {
            queryParameters['stdout'] = requestParameters.stdout;
        }
        if (requestParameters.tty !== undefined) {
            queryParameters['tty'] = requestParameters.tty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/attach`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect GET requests to attach of Pod
     */
    async connectCoreV1GetNamespacedPodAttach(requestParameters, initOverrides) {
        const response = await this.connectCoreV1GetNamespacedPodAttachRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect GET requests to exec of Pod
     */
    async connectCoreV1GetNamespacedPodExecRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1GetNamespacedPodExec.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1GetNamespacedPodExec.');
        }
        const queryParameters = {};
        if (requestParameters.command !== undefined) {
            queryParameters['command'] = requestParameters.command;
        }
        if (requestParameters.container !== undefined) {
            queryParameters['container'] = requestParameters.container;
        }
        if (requestParameters.stderr !== undefined) {
            queryParameters['stderr'] = requestParameters.stderr;
        }
        if (requestParameters.stdin !== undefined) {
            queryParameters['stdin'] = requestParameters.stdin;
        }
        if (requestParameters.stdout !== undefined) {
            queryParameters['stdout'] = requestParameters.stdout;
        }
        if (requestParameters.tty !== undefined) {
            queryParameters['tty'] = requestParameters.tty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/exec`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect GET requests to exec of Pod
     */
    async connectCoreV1GetNamespacedPodExec(requestParameters, initOverrides) {
        const response = await this.connectCoreV1GetNamespacedPodExecRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect GET requests to portforward of Pod
     */
    async connectCoreV1GetNamespacedPodPortforwardRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1GetNamespacedPodPortforward.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1GetNamespacedPodPortforward.');
        }
        const queryParameters = {};
        if (requestParameters.ports !== undefined) {
            queryParameters['ports'] = requestParameters.ports;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/portforward`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect GET requests to portforward of Pod
     */
    async connectCoreV1GetNamespacedPodPortforward(requestParameters, initOverrides) {
        const response = await this.connectCoreV1GetNamespacedPodPortforwardRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect GET requests to proxy of Pod
     */
    async connectCoreV1GetNamespacedPodProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1GetNamespacedPodProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1GetNamespacedPodProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect GET requests to proxy of Pod
     */
    async connectCoreV1GetNamespacedPodProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1GetNamespacedPodProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect GET requests to proxy of Pod
     */
    async connectCoreV1GetNamespacedPodProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1GetNamespacedPodProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1GetNamespacedPodProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1GetNamespacedPodProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect GET requests to proxy of Pod
     */
    async connectCoreV1GetNamespacedPodProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1GetNamespacedPodProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect GET requests to proxy of Service
     */
    async connectCoreV1GetNamespacedServiceProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1GetNamespacedServiceProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1GetNamespacedServiceProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect GET requests to proxy of Service
     */
    async connectCoreV1GetNamespacedServiceProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1GetNamespacedServiceProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect GET requests to proxy of Service
     */
    async connectCoreV1GetNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1GetNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1GetNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1GetNamespacedServiceProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect GET requests to proxy of Service
     */
    async connectCoreV1GetNamespacedServiceProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1GetNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect GET requests to proxy of Node
     */
    async connectCoreV1GetNodeProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1GetNodeProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect GET requests to proxy of Node
     */
    async connectCoreV1GetNodeProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1GetNodeProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect GET requests to proxy of Node
     */
    async connectCoreV1GetNodeProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1GetNodeProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1GetNodeProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect GET requests to proxy of Node
     */
    async connectCoreV1GetNodeProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1GetNodeProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect HEAD requests to proxy of Pod
     */
    async connectCoreV1HeadNamespacedPodProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1HeadNamespacedPodProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1HeadNamespacedPodProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect HEAD requests to proxy of Pod
     */
    async connectCoreV1HeadNamespacedPodProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1HeadNamespacedPodProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect HEAD requests to proxy of Pod
     */
    async connectCoreV1HeadNamespacedPodProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1HeadNamespacedPodProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1HeadNamespacedPodProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1HeadNamespacedPodProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect HEAD requests to proxy of Pod
     */
    async connectCoreV1HeadNamespacedPodProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1HeadNamespacedPodProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect HEAD requests to proxy of Service
     */
    async connectCoreV1HeadNamespacedServiceProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1HeadNamespacedServiceProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1HeadNamespacedServiceProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect HEAD requests to proxy of Service
     */
    async connectCoreV1HeadNamespacedServiceProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1HeadNamespacedServiceProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect HEAD requests to proxy of Service
     */
    async connectCoreV1HeadNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1HeadNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1HeadNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1HeadNamespacedServiceProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect HEAD requests to proxy of Service
     */
    async connectCoreV1HeadNamespacedServiceProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1HeadNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect HEAD requests to proxy of Node
     */
    async connectCoreV1HeadNodeProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1HeadNodeProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect HEAD requests to proxy of Node
     */
    async connectCoreV1HeadNodeProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1HeadNodeProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect HEAD requests to proxy of Node
     */
    async connectCoreV1HeadNodeProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1HeadNodeProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1HeadNodeProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect HEAD requests to proxy of Node
     */
    async connectCoreV1HeadNodeProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1HeadNodeProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect OPTIONS requests to proxy of Pod
     */
    async connectCoreV1OptionsNamespacedPodProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1OptionsNamespacedPodProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1OptionsNamespacedPodProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect OPTIONS requests to proxy of Pod
     */
    async connectCoreV1OptionsNamespacedPodProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1OptionsNamespacedPodProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect OPTIONS requests to proxy of Pod
     */
    async connectCoreV1OptionsNamespacedPodProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1OptionsNamespacedPodProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1OptionsNamespacedPodProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1OptionsNamespacedPodProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect OPTIONS requests to proxy of Pod
     */
    async connectCoreV1OptionsNamespacedPodProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1OptionsNamespacedPodProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect OPTIONS requests to proxy of Service
     */
    async connectCoreV1OptionsNamespacedServiceProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1OptionsNamespacedServiceProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1OptionsNamespacedServiceProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect OPTIONS requests to proxy of Service
     */
    async connectCoreV1OptionsNamespacedServiceProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1OptionsNamespacedServiceProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect OPTIONS requests to proxy of Service
     */
    async connectCoreV1OptionsNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1OptionsNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1OptionsNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1OptionsNamespacedServiceProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect OPTIONS requests to proxy of Service
     */
    async connectCoreV1OptionsNamespacedServiceProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1OptionsNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect OPTIONS requests to proxy of Node
     */
    async connectCoreV1OptionsNodeProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1OptionsNodeProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect OPTIONS requests to proxy of Node
     */
    async connectCoreV1OptionsNodeProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1OptionsNodeProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect OPTIONS requests to proxy of Node
     */
    async connectCoreV1OptionsNodeProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1OptionsNodeProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1OptionsNodeProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect OPTIONS requests to proxy of Node
     */
    async connectCoreV1OptionsNodeProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1OptionsNodeProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PATCH requests to proxy of Pod
     */
    async connectCoreV1PatchNamespacedPodProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PatchNamespacedPodProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PatchNamespacedPodProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PATCH requests to proxy of Pod
     */
    async connectCoreV1PatchNamespacedPodProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PatchNamespacedPodProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PATCH requests to proxy of Pod
     */
    async connectCoreV1PatchNamespacedPodProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PatchNamespacedPodProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PatchNamespacedPodProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1PatchNamespacedPodProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PATCH requests to proxy of Pod
     */
    async connectCoreV1PatchNamespacedPodProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PatchNamespacedPodProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PATCH requests to proxy of Service
     */
    async connectCoreV1PatchNamespacedServiceProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PatchNamespacedServiceProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PatchNamespacedServiceProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PATCH requests to proxy of Service
     */
    async connectCoreV1PatchNamespacedServiceProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PatchNamespacedServiceProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PATCH requests to proxy of Service
     */
    async connectCoreV1PatchNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PatchNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PatchNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1PatchNamespacedServiceProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PATCH requests to proxy of Service
     */
    async connectCoreV1PatchNamespacedServiceProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PatchNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PATCH requests to proxy of Node
     */
    async connectCoreV1PatchNodeProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PatchNodeProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PATCH requests to proxy of Node
     */
    async connectCoreV1PatchNodeProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PatchNodeProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PATCH requests to proxy of Node
     */
    async connectCoreV1PatchNodeProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PatchNodeProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1PatchNodeProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PATCH requests to proxy of Node
     */
    async connectCoreV1PatchNodeProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PatchNodeProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect POST requests to attach of Pod
     */
    async connectCoreV1PostNamespacedPodAttachRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PostNamespacedPodAttach.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PostNamespacedPodAttach.');
        }
        const queryParameters = {};
        if (requestParameters.container !== undefined) {
            queryParameters['container'] = requestParameters.container;
        }
        if (requestParameters.stderr !== undefined) {
            queryParameters['stderr'] = requestParameters.stderr;
        }
        if (requestParameters.stdin !== undefined) {
            queryParameters['stdin'] = requestParameters.stdin;
        }
        if (requestParameters.stdout !== undefined) {
            queryParameters['stdout'] = requestParameters.stdout;
        }
        if (requestParameters.tty !== undefined) {
            queryParameters['tty'] = requestParameters.tty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/attach`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect POST requests to attach of Pod
     */
    async connectCoreV1PostNamespacedPodAttach(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PostNamespacedPodAttachRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect POST requests to exec of Pod
     */
    async connectCoreV1PostNamespacedPodExecRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PostNamespacedPodExec.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PostNamespacedPodExec.');
        }
        const queryParameters = {};
        if (requestParameters.command !== undefined) {
            queryParameters['command'] = requestParameters.command;
        }
        if (requestParameters.container !== undefined) {
            queryParameters['container'] = requestParameters.container;
        }
        if (requestParameters.stderr !== undefined) {
            queryParameters['stderr'] = requestParameters.stderr;
        }
        if (requestParameters.stdin !== undefined) {
            queryParameters['stdin'] = requestParameters.stdin;
        }
        if (requestParameters.stdout !== undefined) {
            queryParameters['stdout'] = requestParameters.stdout;
        }
        if (requestParameters.tty !== undefined) {
            queryParameters['tty'] = requestParameters.tty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/exec`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect POST requests to exec of Pod
     */
    async connectCoreV1PostNamespacedPodExec(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PostNamespacedPodExecRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect POST requests to portforward of Pod
     */
    async connectCoreV1PostNamespacedPodPortforwardRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PostNamespacedPodPortforward.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PostNamespacedPodPortforward.');
        }
        const queryParameters = {};
        if (requestParameters.ports !== undefined) {
            queryParameters['ports'] = requestParameters.ports;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/portforward`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect POST requests to portforward of Pod
     */
    async connectCoreV1PostNamespacedPodPortforward(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PostNamespacedPodPortforwardRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect POST requests to proxy of Pod
     */
    async connectCoreV1PostNamespacedPodProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PostNamespacedPodProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PostNamespacedPodProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect POST requests to proxy of Pod
     */
    async connectCoreV1PostNamespacedPodProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PostNamespacedPodProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect POST requests to proxy of Pod
     */
    async connectCoreV1PostNamespacedPodProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PostNamespacedPodProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PostNamespacedPodProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1PostNamespacedPodProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect POST requests to proxy of Pod
     */
    async connectCoreV1PostNamespacedPodProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PostNamespacedPodProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect POST requests to proxy of Service
     */
    async connectCoreV1PostNamespacedServiceProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PostNamespacedServiceProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PostNamespacedServiceProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect POST requests to proxy of Service
     */
    async connectCoreV1PostNamespacedServiceProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PostNamespacedServiceProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect POST requests to proxy of Service
     */
    async connectCoreV1PostNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PostNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PostNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1PostNamespacedServiceProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect POST requests to proxy of Service
     */
    async connectCoreV1PostNamespacedServiceProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PostNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect POST requests to proxy of Node
     */
    async connectCoreV1PostNodeProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PostNodeProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect POST requests to proxy of Node
     */
    async connectCoreV1PostNodeProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PostNodeProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect POST requests to proxy of Node
     */
    async connectCoreV1PostNodeProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PostNodeProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1PostNodeProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect POST requests to proxy of Node
     */
    async connectCoreV1PostNodeProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PostNodeProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PUT requests to proxy of Pod
     */
    async connectCoreV1PutNamespacedPodProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PutNamespacedPodProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PutNamespacedPodProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PUT requests to proxy of Pod
     */
    async connectCoreV1PutNamespacedPodProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PutNamespacedPodProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PUT requests to proxy of Pod
     */
    async connectCoreV1PutNamespacedPodProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PutNamespacedPodProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PutNamespacedPodProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1PutNamespacedPodProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PUT requests to proxy of Pod
     */
    async connectCoreV1PutNamespacedPodProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PutNamespacedPodProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PUT requests to proxy of Service
     */
    async connectCoreV1PutNamespacedServiceProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PutNamespacedServiceProxy.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PutNamespacedServiceProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PUT requests to proxy of Service
     */
    async connectCoreV1PutNamespacedServiceProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PutNamespacedServiceProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PUT requests to proxy of Service
     */
    async connectCoreV1PutNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PutNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling connectCoreV1PutNamespacedServiceProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1PutNamespacedServiceProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PUT requests to proxy of Service
     */
    async connectCoreV1PutNamespacedServiceProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PutNamespacedServiceProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PUT requests to proxy of Node
     */
    async connectCoreV1PutNodeProxyRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PutNodeProxy.');
        }
        const queryParameters = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PUT requests to proxy of Node
     */
    async connectCoreV1PutNodeProxy(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PutNodeProxyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * connect PUT requests to proxy of Node
     */
    async connectCoreV1PutNodeProxyWithPathRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling connectCoreV1PutNodeProxyWithPath.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling connectCoreV1PutNodeProxyWithPath.');
        }
        const queryParameters = {};
        if (requestParameters.path2 !== undefined) {
            queryParameters['path'] = requestParameters.path2;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/proxy/{path}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * connect PUT requests to proxy of Node
     */
    async connectCoreV1PutNodeProxyWithPath(requestParameters, initOverrides) {
        const response = await this.connectCoreV1PutNodeProxyWithPathRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a Namespace
     */
    async createCoreV1NamespaceRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1Namespace.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1NamespaceToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NamespaceFromJSON(jsonValue));
    }
    /**
     * create a Namespace
     */
    async createCoreV1Namespace(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespaceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a Binding
     */
    async createCoreV1NamespacedBindingRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedBinding.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedBinding.');
        }
        const queryParameters = {};
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/bindings`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1BindingToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1BindingFromJSON(jsonValue));
    }
    /**
     * create a Binding
     */
    async createCoreV1NamespacedBinding(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedBindingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a ConfigMap
     */
    async createCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedConfigMap.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedConfigMap.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/configmaps`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ConfigMapToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ConfigMapFromJSON(jsonValue));
    }
    /**
     * create a ConfigMap
     */
    async createCoreV1NamespacedConfigMap(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create Endpoints
     */
    async createCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedEndpoints.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedEndpoints.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/endpoints`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1EndpointsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EndpointsFromJSON(jsonValue));
    }
    /**
     * create Endpoints
     */
    async createCoreV1NamespacedEndpoints(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create an Event
     */
    async createCoreV1NamespacedEventRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedEvent.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedEvent.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/events`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1EventToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EventFromJSON(jsonValue));
    }
    /**
     * create an Event
     */
    async createCoreV1NamespacedEvent(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedEventRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a LimitRange
     */
    async createCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedLimitRange.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedLimitRange.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/limitranges`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1LimitRangeToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1LimitRangeFromJSON(jsonValue));
    }
    /**
     * create a LimitRange
     */
    async createCoreV1NamespacedLimitRange(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a PersistentVolumeClaim
     */
    async createCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedPersistentVolumeClaim.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedPersistentVolumeClaim.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PersistentVolumeClaimToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimFromJSON(jsonValue));
    }
    /**
     * create a PersistentVolumeClaim
     */
    async createCoreV1NamespacedPersistentVolumeClaim(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a Pod
     */
    async createCoreV1NamespacedPodRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedPod.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedPod.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PodToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * create a Pod
     */
    async createCoreV1NamespacedPod(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedPodRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create binding of a Pod
     */
    async createCoreV1NamespacedPodBindingRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling createCoreV1NamespacedPodBinding.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedPodBinding.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedPodBinding.');
        }
        const queryParameters = {};
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/binding`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1BindingToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1BindingFromJSON(jsonValue));
    }
    /**
     * create binding of a Pod
     */
    async createCoreV1NamespacedPodBinding(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedPodBindingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create eviction of a Pod
     */
    async createCoreV1NamespacedPodEvictionRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling createCoreV1NamespacedPodEviction.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedPodEviction.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedPodEviction.');
        }
        const queryParameters = {};
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/eviction`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiPolicyV1EvictionToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiPolicyV1EvictionFromJSON(jsonValue));
    }
    /**
     * create eviction of a Pod
     */
    async createCoreV1NamespacedPodEviction(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedPodEvictionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a PodTemplate
     */
    async createCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedPodTemplate.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedPodTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/podtemplates`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PodTemplateToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodTemplateFromJSON(jsonValue));
    }
    /**
     * create a PodTemplate
     */
    async createCoreV1NamespacedPodTemplate(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a ReplicationController
     */
    async createCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedReplicationController.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedReplicationController.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ReplicationControllerToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ReplicationControllerFromJSON(jsonValue));
    }
    /**
     * create a ReplicationController
     */
    async createCoreV1NamespacedReplicationController(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a ResourceQuota
     */
    async createCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedResourceQuota.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedResourceQuota.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ResourceQuotaToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaFromJSON(jsonValue));
    }
    /**
     * create a ResourceQuota
     */
    async createCoreV1NamespacedResourceQuota(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a Secret
     */
    async createCoreV1NamespacedSecretRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedSecret.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/secrets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1SecretToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1SecretFromJSON(jsonValue));
    }
    /**
     * create a Secret
     */
    async createCoreV1NamespacedSecret(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a Service
     */
    async createCoreV1NamespacedServiceRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedService.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedService.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ServiceToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceFromJSON(jsonValue));
    }
    /**
     * create a Service
     */
    async createCoreV1NamespacedService(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a ServiceAccount
     */
    async createCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedServiceAccount.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedServiceAccount.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/serviceaccounts`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ServiceAccountToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceAccountFromJSON(jsonValue));
    }
    /**
     * create a ServiceAccount
     */
    async createCoreV1NamespacedServiceAccount(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create token of a ServiceAccount
     */
    async createCoreV1NamespacedServiceAccountTokenRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling createCoreV1NamespacedServiceAccountToken.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createCoreV1NamespacedServiceAccountToken.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1NamespacedServiceAccountToken.');
        }
        const queryParameters = {};
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/serviceaccounts/{name}/token`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAuthenticationV1TokenRequestToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAuthenticationV1TokenRequestFromJSON(jsonValue));
    }
    /**
     * create token of a ServiceAccount
     */
    async createCoreV1NamespacedServiceAccountToken(requestParameters, initOverrides) {
        const response = await this.createCoreV1NamespacedServiceAccountTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a Node
     */
    async createCoreV1NodeRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1Node.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1NodeToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NodeFromJSON(jsonValue));
    }
    /**
     * create a Node
     */
    async createCoreV1Node(requestParameters, initOverrides) {
        const response = await this.createCoreV1NodeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a PersistentVolume
     */
    async createCoreV1PersistentVolumeRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createCoreV1PersistentVolume.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PersistentVolumeToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeFromJSON(jsonValue));
    }
    /**
     * create a PersistentVolume
     */
    async createCoreV1PersistentVolume(requestParameters, initOverrides) {
        const response = await this.createCoreV1PersistentVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of ConfigMap
     */
    async deleteCoreV1CollectionNamespacedConfigMapRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedConfigMap.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/configmaps`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of ConfigMap
     */
    async deleteCoreV1CollectionNamespacedConfigMap(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedConfigMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of Endpoints
     */
    async deleteCoreV1CollectionNamespacedEndpointsRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedEndpoints.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/endpoints`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of Endpoints
     */
    async deleteCoreV1CollectionNamespacedEndpoints(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedEndpointsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of Event
     */
    async deleteCoreV1CollectionNamespacedEventRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedEvent.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/events`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of Event
     */
    async deleteCoreV1CollectionNamespacedEvent(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedEventRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of LimitRange
     */
    async deleteCoreV1CollectionNamespacedLimitRangeRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedLimitRange.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/limitranges`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of LimitRange
     */
    async deleteCoreV1CollectionNamespacedLimitRange(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedLimitRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of PersistentVolumeClaim
     */
    async deleteCoreV1CollectionNamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedPersistentVolumeClaim.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of PersistentVolumeClaim
     */
    async deleteCoreV1CollectionNamespacedPersistentVolumeClaim(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of Pod
     */
    async deleteCoreV1CollectionNamespacedPodRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedPod.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of Pod
     */
    async deleteCoreV1CollectionNamespacedPod(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedPodRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of PodTemplate
     */
    async deleteCoreV1CollectionNamespacedPodTemplateRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedPodTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/podtemplates`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of PodTemplate
     */
    async deleteCoreV1CollectionNamespacedPodTemplate(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedPodTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of ReplicationController
     */
    async deleteCoreV1CollectionNamespacedReplicationControllerRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedReplicationController.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of ReplicationController
     */
    async deleteCoreV1CollectionNamespacedReplicationController(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedReplicationControllerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of ResourceQuota
     */
    async deleteCoreV1CollectionNamespacedResourceQuotaRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedResourceQuota.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of ResourceQuota
     */
    async deleteCoreV1CollectionNamespacedResourceQuota(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedResourceQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of Secret
     */
    async deleteCoreV1CollectionNamespacedSecretRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedSecret.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/secrets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of Secret
     */
    async deleteCoreV1CollectionNamespacedSecret(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of Service
     */
    async deleteCoreV1CollectionNamespacedServiceRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedService.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of Service
     */
    async deleteCoreV1CollectionNamespacedService(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of ServiceAccount
     */
    async deleteCoreV1CollectionNamespacedServiceAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1CollectionNamespacedServiceAccount.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/serviceaccounts`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of ServiceAccount
     */
    async deleteCoreV1CollectionNamespacedServiceAccount(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1CollectionNamespacedServiceAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of Node
     */
    async deleteCoreV1CollectionNodeRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of Node
     */
    async deleteCoreV1CollectionNode(requestParameters = {}, initOverrides) {
        const response = await this.deleteCoreV1CollectionNodeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of PersistentVolume
     */
    async deleteCoreV1CollectionPersistentVolumeRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of PersistentVolume
     */
    async deleteCoreV1CollectionPersistentVolume(requestParameters = {}, initOverrides) {
        const response = await this.deleteCoreV1CollectionPersistentVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a Namespace
     */
    async deleteCoreV1NamespaceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1Namespace.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a Namespace
     */
    async deleteCoreV1Namespace(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespaceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a ConfigMap
     */
    async deleteCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedConfigMap.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedConfigMap.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/configmaps/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a ConfigMap
     */
    async deleteCoreV1NamespacedConfigMap(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete Endpoints
     */
    async deleteCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedEndpoints.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedEndpoints.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/endpoints/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete Endpoints
     */
    async deleteCoreV1NamespacedEndpoints(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete an Event
     */
    async deleteCoreV1NamespacedEventRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedEvent.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedEvent.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/events/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete an Event
     */
    async deleteCoreV1NamespacedEvent(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedEventRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a LimitRange
     */
    async deleteCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedLimitRange.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedLimitRange.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/limitranges/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a LimitRange
     */
    async deleteCoreV1NamespacedLimitRange(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a PersistentVolumeClaim
     */
    async deleteCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedPersistentVolumeClaim.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedPersistentVolumeClaim.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimFromJSON(jsonValue));
    }
    /**
     * delete a PersistentVolumeClaim
     */
    async deleteCoreV1NamespacedPersistentVolumeClaim(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a Pod
     */
    async deleteCoreV1NamespacedPodRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedPod.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedPod.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * delete a Pod
     */
    async deleteCoreV1NamespacedPod(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedPodRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a PodTemplate
     */
    async deleteCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedPodTemplate.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedPodTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/podtemplates/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodTemplateFromJSON(jsonValue));
    }
    /**
     * delete a PodTemplate
     */
    async deleteCoreV1NamespacedPodTemplate(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a ReplicationController
     */
    async deleteCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedReplicationController.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedReplicationController.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a ReplicationController
     */
    async deleteCoreV1NamespacedReplicationController(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a ResourceQuota
     */
    async deleteCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedResourceQuota.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedResourceQuota.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaFromJSON(jsonValue));
    }
    /**
     * delete a ResourceQuota
     */
    async deleteCoreV1NamespacedResourceQuota(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a Secret
     */
    async deleteCoreV1NamespacedSecretRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedSecret.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedSecret.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/secrets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a Secret
     */
    async deleteCoreV1NamespacedSecret(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a Service
     */
    async deleteCoreV1NamespacedServiceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedService.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedService.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceFromJSON(jsonValue));
    }
    /**
     * delete a Service
     */
    async deleteCoreV1NamespacedService(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a ServiceAccount
     */
    async deleteCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1NamespacedServiceAccount.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteCoreV1NamespacedServiceAccount.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/serviceaccounts/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceAccountFromJSON(jsonValue));
    }
    /**
     * delete a ServiceAccount
     */
    async deleteCoreV1NamespacedServiceAccount(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a Node
     */
    async deleteCoreV1NodeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1Node.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a Node
     */
    async deleteCoreV1Node(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1NodeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a PersistentVolume
     */
    async deleteCoreV1PersistentVolumeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteCoreV1PersistentVolume.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeFromJSON(jsonValue));
    }
    /**
     * delete a PersistentVolume
     */
    async deleteCoreV1PersistentVolume(requestParameters, initOverrides) {
        const response = await this.deleteCoreV1PersistentVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * get available resources
     */
    async getCoreV1APIResourcesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1APIResourceListFromJSON(jsonValue));
    }
    /**
     * get available resources
     */
    async getCoreV1APIResources(initOverrides) {
        const response = await this.getCoreV1APIResourcesRaw(initOverrides);
        return await response.value();
    }
    /**
     * list objects of kind ComponentStatus
     */
    async listCoreV1ComponentStatusRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/componentstatuses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ComponentStatusListFromJSON(jsonValue));
    }
    /**
     * list objects of kind ComponentStatus
     */
    async listCoreV1ComponentStatus(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1ComponentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ConfigMap
     */
    async listCoreV1ConfigMapForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/configmaps`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ConfigMapListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ConfigMap
     */
    async listCoreV1ConfigMapForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1ConfigMapForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Endpoints
     */
    async listCoreV1EndpointsForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/endpoints`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EndpointsListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Endpoints
     */
    async listCoreV1EndpointsForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1EndpointsForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Event
     */
    async listCoreV1EventForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EventListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Event
     */
    async listCoreV1EventForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1EventForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind LimitRange
     */
    async listCoreV1LimitRangeForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/limitranges`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1LimitRangeListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind LimitRange
     */
    async listCoreV1LimitRangeForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1LimitRangeForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Namespace
     */
    async listCoreV1NamespaceRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NamespaceListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Namespace
     */
    async listCoreV1Namespace(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1NamespaceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ConfigMap
     */
    async listCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedConfigMap.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/configmaps`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ConfigMapListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ConfigMap
     */
    async listCoreV1NamespacedConfigMap(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Endpoints
     */
    async listCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedEndpoints.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/endpoints`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EndpointsListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Endpoints
     */
    async listCoreV1NamespacedEndpoints(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Event
     */
    async listCoreV1NamespacedEventRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedEvent.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/events`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EventListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Event
     */
    async listCoreV1NamespacedEvent(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedEventRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind LimitRange
     */
    async listCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedLimitRange.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/limitranges`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1LimitRangeListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind LimitRange
     */
    async listCoreV1NamespacedLimitRange(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind PersistentVolumeClaim
     */
    async listCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedPersistentVolumeClaim.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind PersistentVolumeClaim
     */
    async listCoreV1NamespacedPersistentVolumeClaim(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Pod
     */
    async listCoreV1NamespacedPodRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedPod.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Pod
     */
    async listCoreV1NamespacedPod(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedPodRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind PodTemplate
     */
    async listCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedPodTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/podtemplates`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodTemplateListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind PodTemplate
     */
    async listCoreV1NamespacedPodTemplate(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ReplicationController
     */
    async listCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedReplicationController.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ReplicationControllerListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ReplicationController
     */
    async listCoreV1NamespacedReplicationController(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ResourceQuota
     */
    async listCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedResourceQuota.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ResourceQuota
     */
    async listCoreV1NamespacedResourceQuota(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Secret
     */
    async listCoreV1NamespacedSecretRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedSecret.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/secrets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1SecretListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Secret
     */
    async listCoreV1NamespacedSecret(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Service
     */
    async listCoreV1NamespacedServiceRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedService.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Service
     */
    async listCoreV1NamespacedService(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ServiceAccount
     */
    async listCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listCoreV1NamespacedServiceAccount.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/serviceaccounts`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceAccountListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ServiceAccount
     */
    async listCoreV1NamespacedServiceAccount(requestParameters, initOverrides) {
        const response = await this.listCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Node
     */
    async listCoreV1NodeRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NodeListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Node
     */
    async listCoreV1Node(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1NodeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind PersistentVolume
     */
    async listCoreV1PersistentVolumeRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind PersistentVolume
     */
    async listCoreV1PersistentVolume(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1PersistentVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind PersistentVolumeClaim
     */
    async listCoreV1PersistentVolumeClaimForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumeclaims`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind PersistentVolumeClaim
     */
    async listCoreV1PersistentVolumeClaimForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1PersistentVolumeClaimForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Pod
     */
    async listCoreV1PodForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/pods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Pod
     */
    async listCoreV1PodForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1PodForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind PodTemplate
     */
    async listCoreV1PodTemplateForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/podtemplates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodTemplateListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind PodTemplate
     */
    async listCoreV1PodTemplateForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1PodTemplateForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ReplicationController
     */
    async listCoreV1ReplicationControllerForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/replicationcontrollers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ReplicationControllerListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ReplicationController
     */
    async listCoreV1ReplicationControllerForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1ReplicationControllerForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ResourceQuota
     */
    async listCoreV1ResourceQuotaForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/resourcequotas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ResourceQuota
     */
    async listCoreV1ResourceQuotaForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1ResourceQuotaForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Secret
     */
    async listCoreV1SecretForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/secrets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1SecretListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Secret
     */
    async listCoreV1SecretForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1SecretForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ServiceAccount
     */
    async listCoreV1ServiceAccountForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/serviceaccounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceAccountListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ServiceAccount
     */
    async listCoreV1ServiceAccountForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1ServiceAccountForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Service
     */
    async listCoreV1ServiceForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/services`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Service
     */
    async listCoreV1ServiceForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listCoreV1ServiceForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified Namespace
     */
    async patchCoreV1NamespaceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1Namespace.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1Namespace.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NamespaceFromJSON(jsonValue));
    }
    /**
     * partially update the specified Namespace
     */
    async patchCoreV1Namespace(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespaceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified Namespace
     */
    async patchCoreV1NamespaceStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespaceStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespaceStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NamespaceFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified Namespace
     */
    async patchCoreV1NamespaceStatus(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespaceStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified ConfigMap
     */
    async patchCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedConfigMap.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedConfigMap.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedConfigMap.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/configmaps/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ConfigMapFromJSON(jsonValue));
    }
    /**
     * partially update the specified ConfigMap
     */
    async patchCoreV1NamespacedConfigMap(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified Endpoints
     */
    async patchCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedEndpoints.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedEndpoints.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedEndpoints.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/endpoints/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EndpointsFromJSON(jsonValue));
    }
    /**
     * partially update the specified Endpoints
     */
    async patchCoreV1NamespacedEndpoints(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified Event
     */
    async patchCoreV1NamespacedEventRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedEvent.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedEvent.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedEvent.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/events/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EventFromJSON(jsonValue));
    }
    /**
     * partially update the specified Event
     */
    async patchCoreV1NamespacedEvent(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedEventRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified LimitRange
     */
    async patchCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedLimitRange.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedLimitRange.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedLimitRange.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/limitranges/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1LimitRangeFromJSON(jsonValue));
    }
    /**
     * partially update the specified LimitRange
     */
    async patchCoreV1NamespacedLimitRange(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified PersistentVolumeClaim
     */
    async patchCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedPersistentVolumeClaim.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedPersistentVolumeClaim.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedPersistentVolumeClaim.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimFromJSON(jsonValue));
    }
    /**
     * partially update the specified PersistentVolumeClaim
     */
    async patchCoreV1NamespacedPersistentVolumeClaim(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified PersistentVolumeClaim
     */
    async patchCoreV1NamespacedPersistentVolumeClaimStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedPersistentVolumeClaimStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedPersistentVolumeClaimStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedPersistentVolumeClaimStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified PersistentVolumeClaim
     */
    async patchCoreV1NamespacedPersistentVolumeClaimStatus(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedPersistentVolumeClaimStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified Pod
     */
    async patchCoreV1NamespacedPodRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedPod.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedPod.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedPod.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * partially update the specified Pod
     */
    async patchCoreV1NamespacedPod(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedPodRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update ephemeralcontainers of the specified Pod
     */
    async patchCoreV1NamespacedPodEphemeralcontainersRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedPodEphemeralcontainers.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedPodEphemeralcontainers.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedPodEphemeralcontainers.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/ephemeralcontainers`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * partially update ephemeralcontainers of the specified Pod
     */
    async patchCoreV1NamespacedPodEphemeralcontainers(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedPodEphemeralcontainersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified Pod
     */
    async patchCoreV1NamespacedPodStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedPodStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedPodStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedPodStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified Pod
     */
    async patchCoreV1NamespacedPodStatus(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedPodStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified PodTemplate
     */
    async patchCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedPodTemplate.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedPodTemplate.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedPodTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/podtemplates/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodTemplateFromJSON(jsonValue));
    }
    /**
     * partially update the specified PodTemplate
     */
    async patchCoreV1NamespacedPodTemplate(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified ReplicationController
     */
    async patchCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedReplicationController.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedReplicationController.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedReplicationController.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ReplicationControllerFromJSON(jsonValue));
    }
    /**
     * partially update the specified ReplicationController
     */
    async patchCoreV1NamespacedReplicationController(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update scale of the specified ReplicationController
     */
    async patchCoreV1NamespacedReplicationControllerScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedReplicationControllerScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedReplicationControllerScale.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedReplicationControllerScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * partially update scale of the specified ReplicationController
     */
    async patchCoreV1NamespacedReplicationControllerScale(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedReplicationControllerScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified ReplicationController
     */
    async patchCoreV1NamespacedReplicationControllerStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedReplicationControllerStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedReplicationControllerStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedReplicationControllerStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ReplicationControllerFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified ReplicationController
     */
    async patchCoreV1NamespacedReplicationControllerStatus(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedReplicationControllerStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified ResourceQuota
     */
    async patchCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedResourceQuota.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedResourceQuota.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedResourceQuota.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaFromJSON(jsonValue));
    }
    /**
     * partially update the specified ResourceQuota
     */
    async patchCoreV1NamespacedResourceQuota(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified ResourceQuota
     */
    async patchCoreV1NamespacedResourceQuotaStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedResourceQuotaStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedResourceQuotaStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedResourceQuotaStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified ResourceQuota
     */
    async patchCoreV1NamespacedResourceQuotaStatus(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedResourceQuotaStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified Secret
     */
    async patchCoreV1NamespacedSecretRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedSecret.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedSecret.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/secrets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1SecretFromJSON(jsonValue));
    }
    /**
     * partially update the specified Secret
     */
    async patchCoreV1NamespacedSecret(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified Service
     */
    async patchCoreV1NamespacedServiceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedService.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedService.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedService.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceFromJSON(jsonValue));
    }
    /**
     * partially update the specified Service
     */
    async patchCoreV1NamespacedService(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified ServiceAccount
     */
    async patchCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedServiceAccount.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedServiceAccount.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedServiceAccount.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/serviceaccounts/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceAccountFromJSON(jsonValue));
    }
    /**
     * partially update the specified ServiceAccount
     */
    async patchCoreV1NamespacedServiceAccount(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified Service
     */
    async patchCoreV1NamespacedServiceStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NamespacedServiceStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchCoreV1NamespacedServiceStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NamespacedServiceStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified Service
     */
    async patchCoreV1NamespacedServiceStatus(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NamespacedServiceStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified Node
     */
    async patchCoreV1NodeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1Node.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1Node.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NodeFromJSON(jsonValue));
    }
    /**
     * partially update the specified Node
     */
    async patchCoreV1Node(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NodeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified Node
     */
    async patchCoreV1NodeStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1NodeStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1NodeStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NodeFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified Node
     */
    async patchCoreV1NodeStatus(requestParameters, initOverrides) {
        const response = await this.patchCoreV1NodeStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified PersistentVolume
     */
    async patchCoreV1PersistentVolumeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1PersistentVolume.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1PersistentVolume.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeFromJSON(jsonValue));
    }
    /**
     * partially update the specified PersistentVolume
     */
    async patchCoreV1PersistentVolume(requestParameters, initOverrides) {
        const response = await this.patchCoreV1PersistentVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified PersistentVolume
     */
    async patchCoreV1PersistentVolumeStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchCoreV1PersistentVolumeStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchCoreV1PersistentVolumeStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified PersistentVolume
     */
    async patchCoreV1PersistentVolumeStatus(requestParameters, initOverrides) {
        const response = await this.patchCoreV1PersistentVolumeStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified ComponentStatus
     */
    async readCoreV1ComponentStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1ComponentStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/componentstatuses/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ComponentStatusFromJSON(jsonValue));
    }
    /**
     * read the specified ComponentStatus
     */
    async readCoreV1ComponentStatus(requestParameters, initOverrides) {
        const response = await this.readCoreV1ComponentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified Namespace
     */
    async readCoreV1NamespaceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1Namespace.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NamespaceFromJSON(jsonValue));
    }
    /**
     * read the specified Namespace
     */
    async readCoreV1Namespace(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespaceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified Namespace
     */
    async readCoreV1NamespaceStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespaceStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NamespaceFromJSON(jsonValue));
    }
    /**
     * read status of the specified Namespace
     */
    async readCoreV1NamespaceStatus(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespaceStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified ConfigMap
     */
    async readCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedConfigMap.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedConfigMap.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/configmaps/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ConfigMapFromJSON(jsonValue));
    }
    /**
     * read the specified ConfigMap
     */
    async readCoreV1NamespacedConfigMap(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified Endpoints
     */
    async readCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedEndpoints.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedEndpoints.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/endpoints/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EndpointsFromJSON(jsonValue));
    }
    /**
     * read the specified Endpoints
     */
    async readCoreV1NamespacedEndpoints(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified Event
     */
    async readCoreV1NamespacedEventRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedEvent.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedEvent.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/events/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EventFromJSON(jsonValue));
    }
    /**
     * read the specified Event
     */
    async readCoreV1NamespacedEvent(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedEventRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified LimitRange
     */
    async readCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedLimitRange.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedLimitRange.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/limitranges/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1LimitRangeFromJSON(jsonValue));
    }
    /**
     * read the specified LimitRange
     */
    async readCoreV1NamespacedLimitRange(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified PersistentVolumeClaim
     */
    async readCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedPersistentVolumeClaim.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedPersistentVolumeClaim.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimFromJSON(jsonValue));
    }
    /**
     * read the specified PersistentVolumeClaim
     */
    async readCoreV1NamespacedPersistentVolumeClaim(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified PersistentVolumeClaim
     */
    async readCoreV1NamespacedPersistentVolumeClaimStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedPersistentVolumeClaimStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedPersistentVolumeClaimStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimFromJSON(jsonValue));
    }
    /**
     * read status of the specified PersistentVolumeClaim
     */
    async readCoreV1NamespacedPersistentVolumeClaimStatus(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedPersistentVolumeClaimStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified Pod
     */
    async readCoreV1NamespacedPodRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedPod.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedPod.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * read the specified Pod
     */
    async readCoreV1NamespacedPod(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedPodRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read ephemeralcontainers of the specified Pod
     */
    async readCoreV1NamespacedPodEphemeralcontainersRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedPodEphemeralcontainers.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedPodEphemeralcontainers.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/ephemeralcontainers`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * read ephemeralcontainers of the specified Pod
     */
    async readCoreV1NamespacedPodEphemeralcontainers(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedPodEphemeralcontainersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read log of the specified Pod
     */
    async readCoreV1NamespacedPodLogRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedPodLog.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedPodLog.');
        }
        const queryParameters = {};
        if (requestParameters.container !== undefined) {
            queryParameters['container'] = requestParameters.container;
        }
        if (requestParameters.follow !== undefined) {
            queryParameters['follow'] = requestParameters.follow;
        }
        if (requestParameters.insecureSkipTLSVerifyBackend !== undefined) {
            queryParameters['insecureSkipTLSVerifyBackend'] = requestParameters.insecureSkipTLSVerifyBackend;
        }
        if (requestParameters.limitBytes !== undefined) {
            queryParameters['limitBytes'] = requestParameters.limitBytes;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.previous !== undefined) {
            queryParameters['previous'] = requestParameters.previous;
        }
        if (requestParameters.sinceSeconds !== undefined) {
            queryParameters['sinceSeconds'] = requestParameters.sinceSeconds;
        }
        if (requestParameters.tailLines !== undefined) {
            queryParameters['tailLines'] = requestParameters.tailLines;
        }
        if (requestParameters.timestamps !== undefined) {
            queryParameters['timestamps'] = requestParameters.timestamps;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/log`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * read log of the specified Pod
     */
    async readCoreV1NamespacedPodLog(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedPodLogRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified Pod
     */
    async readCoreV1NamespacedPodStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedPodStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedPodStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * read status of the specified Pod
     */
    async readCoreV1NamespacedPodStatus(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedPodStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified PodTemplate
     */
    async readCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedPodTemplate.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedPodTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/podtemplates/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodTemplateFromJSON(jsonValue));
    }
    /**
     * read the specified PodTemplate
     */
    async readCoreV1NamespacedPodTemplate(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified ReplicationController
     */
    async readCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedReplicationController.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedReplicationController.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ReplicationControllerFromJSON(jsonValue));
    }
    /**
     * read the specified ReplicationController
     */
    async readCoreV1NamespacedReplicationController(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read scale of the specified ReplicationController
     */
    async readCoreV1NamespacedReplicationControllerScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedReplicationControllerScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedReplicationControllerScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * read scale of the specified ReplicationController
     */
    async readCoreV1NamespacedReplicationControllerScale(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedReplicationControllerScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified ReplicationController
     */
    async readCoreV1NamespacedReplicationControllerStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedReplicationControllerStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedReplicationControllerStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ReplicationControllerFromJSON(jsonValue));
    }
    /**
     * read status of the specified ReplicationController
     */
    async readCoreV1NamespacedReplicationControllerStatus(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedReplicationControllerStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified ResourceQuota
     */
    async readCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedResourceQuota.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedResourceQuota.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaFromJSON(jsonValue));
    }
    /**
     * read the specified ResourceQuota
     */
    async readCoreV1NamespacedResourceQuota(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified ResourceQuota
     */
    async readCoreV1NamespacedResourceQuotaStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedResourceQuotaStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedResourceQuotaStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaFromJSON(jsonValue));
    }
    /**
     * read status of the specified ResourceQuota
     */
    async readCoreV1NamespacedResourceQuotaStatus(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedResourceQuotaStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified Secret
     */
    async readCoreV1NamespacedSecretRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedSecret.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedSecret.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/secrets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1SecretFromJSON(jsonValue));
    }
    /**
     * read the specified Secret
     */
    async readCoreV1NamespacedSecret(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified Service
     */
    async readCoreV1NamespacedServiceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedService.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedService.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceFromJSON(jsonValue));
    }
    /**
     * read the specified Service
     */
    async readCoreV1NamespacedService(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified ServiceAccount
     */
    async readCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedServiceAccount.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedServiceAccount.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/serviceaccounts/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceAccountFromJSON(jsonValue));
    }
    /**
     * read the specified ServiceAccount
     */
    async readCoreV1NamespacedServiceAccount(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified Service
     */
    async readCoreV1NamespacedServiceStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NamespacedServiceStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readCoreV1NamespacedServiceStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceFromJSON(jsonValue));
    }
    /**
     * read status of the specified Service
     */
    async readCoreV1NamespacedServiceStatus(requestParameters, initOverrides) {
        const response = await this.readCoreV1NamespacedServiceStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified Node
     */
    async readCoreV1NodeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1Node.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NodeFromJSON(jsonValue));
    }
    /**
     * read the specified Node
     */
    async readCoreV1Node(requestParameters, initOverrides) {
        const response = await this.readCoreV1NodeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified Node
     */
    async readCoreV1NodeStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1NodeStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NodeFromJSON(jsonValue));
    }
    /**
     * read status of the specified Node
     */
    async readCoreV1NodeStatus(requestParameters, initOverrides) {
        const response = await this.readCoreV1NodeStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified PersistentVolume
     */
    async readCoreV1PersistentVolumeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1PersistentVolume.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeFromJSON(jsonValue));
    }
    /**
     * read the specified PersistentVolume
     */
    async readCoreV1PersistentVolume(requestParameters, initOverrides) {
        const response = await this.readCoreV1PersistentVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified PersistentVolume
     */
    async readCoreV1PersistentVolumeStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readCoreV1PersistentVolumeStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeFromJSON(jsonValue));
    }
    /**
     * read status of the specified PersistentVolume
     */
    async readCoreV1PersistentVolumeStatus(requestParameters, initOverrides) {
        const response = await this.readCoreV1PersistentVolumeStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified Namespace
     */
    async replaceCoreV1NamespaceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1Namespace.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1Namespace.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1NamespaceToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NamespaceFromJSON(jsonValue));
    }
    /**
     * replace the specified Namespace
     */
    async replaceCoreV1Namespace(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespaceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace finalize of the specified Namespace
     */
    async replaceCoreV1NamespaceFinalizeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespaceFinalize.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespaceFinalize.');
        }
        const queryParameters = {};
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{name}/finalize`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1NamespaceToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NamespaceFromJSON(jsonValue));
    }
    /**
     * replace finalize of the specified Namespace
     */
    async replaceCoreV1NamespaceFinalize(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespaceFinalizeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified Namespace
     */
    async replaceCoreV1NamespaceStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespaceStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespaceStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1NamespaceToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NamespaceFromJSON(jsonValue));
    }
    /**
     * replace status of the specified Namespace
     */
    async replaceCoreV1NamespaceStatus(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespaceStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified ConfigMap
     */
    async replaceCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedConfigMap.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedConfigMap.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedConfigMap.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/configmaps/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ConfigMapToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ConfigMapFromJSON(jsonValue));
    }
    /**
     * replace the specified ConfigMap
     */
    async replaceCoreV1NamespacedConfigMap(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified Endpoints
     */
    async replaceCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedEndpoints.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedEndpoints.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedEndpoints.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/endpoints/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1EndpointsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EndpointsFromJSON(jsonValue));
    }
    /**
     * replace the specified Endpoints
     */
    async replaceCoreV1NamespacedEndpoints(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified Event
     */
    async replaceCoreV1NamespacedEventRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedEvent.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedEvent.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedEvent.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/events/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1EventToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1EventFromJSON(jsonValue));
    }
    /**
     * replace the specified Event
     */
    async replaceCoreV1NamespacedEvent(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedEventRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified LimitRange
     */
    async replaceCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedLimitRange.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedLimitRange.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedLimitRange.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/limitranges/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1LimitRangeToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1LimitRangeFromJSON(jsonValue));
    }
    /**
     * replace the specified LimitRange
     */
    async replaceCoreV1NamespacedLimitRange(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified PersistentVolumeClaim
     */
    async replaceCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedPersistentVolumeClaim.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedPersistentVolumeClaim.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedPersistentVolumeClaim.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PersistentVolumeClaimToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimFromJSON(jsonValue));
    }
    /**
     * replace the specified PersistentVolumeClaim
     */
    async replaceCoreV1NamespacedPersistentVolumeClaim(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified PersistentVolumeClaim
     */
    async replaceCoreV1NamespacedPersistentVolumeClaimStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedPersistentVolumeClaimStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedPersistentVolumeClaimStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedPersistentVolumeClaimStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/persistentvolumeclaims/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PersistentVolumeClaimToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeClaimFromJSON(jsonValue));
    }
    /**
     * replace status of the specified PersistentVolumeClaim
     */
    async replaceCoreV1NamespacedPersistentVolumeClaimStatus(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedPersistentVolumeClaimStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified Pod
     */
    async replaceCoreV1NamespacedPodRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedPod.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedPod.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedPod.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PodToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * replace the specified Pod
     */
    async replaceCoreV1NamespacedPod(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedPodRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace ephemeralcontainers of the specified Pod
     */
    async replaceCoreV1NamespacedPodEphemeralcontainersRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedPodEphemeralcontainers.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedPodEphemeralcontainers.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedPodEphemeralcontainers.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/ephemeralcontainers`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PodToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * replace ephemeralcontainers of the specified Pod
     */
    async replaceCoreV1NamespacedPodEphemeralcontainers(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedPodEphemeralcontainersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified Pod
     */
    async replaceCoreV1NamespacedPodStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedPodStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedPodStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedPodStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/pods/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PodToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodFromJSON(jsonValue));
    }
    /**
     * replace status of the specified Pod
     */
    async replaceCoreV1NamespacedPodStatus(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedPodStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified PodTemplate
     */
    async replaceCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedPodTemplate.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedPodTemplate.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedPodTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/podtemplates/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PodTemplateToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PodTemplateFromJSON(jsonValue));
    }
    /**
     * replace the specified PodTemplate
     */
    async replaceCoreV1NamespacedPodTemplate(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified ReplicationController
     */
    async replaceCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedReplicationController.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedReplicationController.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedReplicationController.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ReplicationControllerToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ReplicationControllerFromJSON(jsonValue));
    }
    /**
     * replace the specified ReplicationController
     */
    async replaceCoreV1NamespacedReplicationController(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace scale of the specified ReplicationController
     */
    async replaceCoreV1NamespacedReplicationControllerScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedReplicationControllerScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedReplicationControllerScale.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedReplicationControllerScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAutoscalingV1ScaleToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * replace scale of the specified ReplicationController
     */
    async replaceCoreV1NamespacedReplicationControllerScale(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedReplicationControllerScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified ReplicationController
     */
    async replaceCoreV1NamespacedReplicationControllerStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedReplicationControllerStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedReplicationControllerStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedReplicationControllerStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/replicationcontrollers/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ReplicationControllerToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ReplicationControllerFromJSON(jsonValue));
    }
    /**
     * replace status of the specified ReplicationController
     */
    async replaceCoreV1NamespacedReplicationControllerStatus(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedReplicationControllerStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified ResourceQuota
     */
    async replaceCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedResourceQuota.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedResourceQuota.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedResourceQuota.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ResourceQuotaToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaFromJSON(jsonValue));
    }
    /**
     * replace the specified ResourceQuota
     */
    async replaceCoreV1NamespacedResourceQuota(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified ResourceQuota
     */
    async replaceCoreV1NamespacedResourceQuotaStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedResourceQuotaStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedResourceQuotaStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedResourceQuotaStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/resourcequotas/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ResourceQuotaToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ResourceQuotaFromJSON(jsonValue));
    }
    /**
     * replace status of the specified ResourceQuota
     */
    async replaceCoreV1NamespacedResourceQuotaStatus(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedResourceQuotaStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified Secret
     */
    async replaceCoreV1NamespacedSecretRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedSecret.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedSecret.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/secrets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1SecretToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1SecretFromJSON(jsonValue));
    }
    /**
     * replace the specified Secret
     */
    async replaceCoreV1NamespacedSecret(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified Service
     */
    async replaceCoreV1NamespacedServiceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedService.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedService.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedService.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ServiceToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceFromJSON(jsonValue));
    }
    /**
     * replace the specified Service
     */
    async replaceCoreV1NamespacedService(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified ServiceAccount
     */
    async replaceCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedServiceAccount.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedServiceAccount.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedServiceAccount.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/serviceaccounts/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ServiceAccountToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceAccountFromJSON(jsonValue));
    }
    /**
     * replace the specified ServiceAccount
     */
    async replaceCoreV1NamespacedServiceAccount(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified Service
     */
    async replaceCoreV1NamespacedServiceStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NamespacedServiceStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceCoreV1NamespacedServiceStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NamespacedServiceStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/namespaces/{namespace}/services/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1ServiceToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1ServiceFromJSON(jsonValue));
    }
    /**
     * replace status of the specified Service
     */
    async replaceCoreV1NamespacedServiceStatus(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NamespacedServiceStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified Node
     */
    async replaceCoreV1NodeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1Node.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1Node.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1NodeToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NodeFromJSON(jsonValue));
    }
    /**
     * replace the specified Node
     */
    async replaceCoreV1Node(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NodeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified Node
     */
    async replaceCoreV1NodeStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1NodeStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1NodeStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/nodes/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1NodeToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1NodeFromJSON(jsonValue));
    }
    /**
     * replace status of the specified Node
     */
    async replaceCoreV1NodeStatus(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1NodeStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified PersistentVolume
     */
    async replaceCoreV1PersistentVolumeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1PersistentVolume.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1PersistentVolume.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PersistentVolumeToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeFromJSON(jsonValue));
    }
    /**
     * replace the specified PersistentVolume
     */
    async replaceCoreV1PersistentVolume(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1PersistentVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified PersistentVolume
     */
    async replaceCoreV1PersistentVolumeStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceCoreV1PersistentVolumeStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceCoreV1PersistentVolumeStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/persistentvolumes/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiCoreV1PersistentVolumeToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiCoreV1PersistentVolumeFromJSON(jsonValue));
    }
    /**
     * replace status of the specified PersistentVolume
     */
    async replaceCoreV1PersistentVolumeStatus(requestParameters, initOverrides) {
        const response = await this.replaceCoreV1PersistentVolumeStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ConfigMap. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ConfigMapListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/configmaps`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ConfigMap. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ConfigMapListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1ConfigMapListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Endpoints. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1EndpointsListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/endpoints`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Endpoints. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1EndpointsListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1EndpointsListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Event. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1EventListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Event. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1EventListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1EventListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of LimitRange. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1LimitRangeListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/limitranges`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of LimitRange. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1LimitRangeListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1LimitRangeListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind Namespace. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespaceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1Namespace.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind Namespace. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1Namespace(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespaceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Namespace. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespaceListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Namespace. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespaceList(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1NamespaceListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind ConfigMap. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedConfigMap.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedConfigMap.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/configmaps/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind ConfigMap. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedConfigMap(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedConfigMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ConfigMap. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedConfigMapListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedConfigMapList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/configmaps`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ConfigMap. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedConfigMapList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedConfigMapListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind Endpoints. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedEndpoints.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedEndpoints.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/endpoints/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind Endpoints. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedEndpoints(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedEndpointsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Endpoints. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedEndpointsListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedEndpointsList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/endpoints`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Endpoints. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedEndpointsList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedEndpointsListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind Event. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedEventRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedEvent.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedEvent.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/events/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind Event. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedEvent(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedEventRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Event. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedEventListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedEventList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/events`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Event. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedEventList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedEventListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind LimitRange. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedLimitRange.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedLimitRange.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/limitranges/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind LimitRange. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedLimitRange(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedLimitRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of LimitRange. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedLimitRangeListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedLimitRangeList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/limitranges`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of LimitRange. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedLimitRangeList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedLimitRangeListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind PersistentVolumeClaim. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedPersistentVolumeClaim.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedPersistentVolumeClaim.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/persistentvolumeclaims/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind PersistentVolumeClaim. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedPersistentVolumeClaim(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedPersistentVolumeClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of PersistentVolumeClaim. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedPersistentVolumeClaimListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedPersistentVolumeClaimList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/persistentvolumeclaims`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of PersistentVolumeClaim. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedPersistentVolumeClaimList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedPersistentVolumeClaimListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind Pod. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedPodRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedPod.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedPod.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/pods/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind Pod. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedPod(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedPodRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Pod. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedPodListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedPodList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/pods`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Pod. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedPodList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedPodListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind PodTemplate. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedPodTemplate.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedPodTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/podtemplates/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind PodTemplate. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedPodTemplate(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedPodTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of PodTemplate. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedPodTemplateListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedPodTemplateList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/podtemplates`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of PodTemplate. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedPodTemplateList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedPodTemplateListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind ReplicationController. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedReplicationController.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedReplicationController.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/replicationcontrollers/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind ReplicationController. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedReplicationController(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedReplicationControllerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ReplicationController. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedReplicationControllerListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedReplicationControllerList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/replicationcontrollers`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ReplicationController. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedReplicationControllerList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedReplicationControllerListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind ResourceQuota. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedResourceQuota.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedResourceQuota.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/resourcequotas/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind ResourceQuota. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedResourceQuota(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedResourceQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ResourceQuota. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedResourceQuotaListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedResourceQuotaList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/resourcequotas`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ResourceQuota. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedResourceQuotaList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedResourceQuotaListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind Secret. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedSecretRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedSecret.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedSecret.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/secrets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind Secret. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedSecret(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Secret. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedSecretListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedSecretList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/secrets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Secret. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedSecretList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedSecretListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind Service. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedServiceRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedService.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedService.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/services/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind Service. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedService(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind ServiceAccount. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1NamespacedServiceAccount.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedServiceAccount.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/serviceaccounts/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind ServiceAccount. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NamespacedServiceAccount(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedServiceAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ServiceAccount. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedServiceAccountListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedServiceAccountList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/serviceaccounts`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ServiceAccount. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedServiceAccountList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedServiceAccountListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Service. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedServiceListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchCoreV1NamespacedServiceList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/namespaces/{namespace}/services`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Service. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NamespacedServiceList(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NamespacedServiceListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind Node. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1NodeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1Node.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/nodes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind Node. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1Node(requestParameters, initOverrides) {
        const response = await this.watchCoreV1NodeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Node. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NodeListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/nodes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Node. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1NodeList(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1NodeListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind PersistentVolume. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1PersistentVolumeRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchCoreV1PersistentVolume.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/persistentvolumes/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind PersistentVolume. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchCoreV1PersistentVolume(requestParameters, initOverrides) {
        const response = await this.watchCoreV1PersistentVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of PersistentVolumeClaim. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1PersistentVolumeClaimListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/persistentvolumeclaims`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of PersistentVolumeClaim. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1PersistentVolumeClaimListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1PersistentVolumeClaimListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of PersistentVolume. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1PersistentVolumeListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/persistentvolumes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of PersistentVolume. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1PersistentVolumeList(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1PersistentVolumeListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Pod. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1PodListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/pods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Pod. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1PodListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1PodListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of PodTemplate. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1PodTemplateListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/podtemplates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of PodTemplate. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1PodTemplateListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1PodTemplateListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ReplicationController. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ReplicationControllerListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/replicationcontrollers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ReplicationController. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ReplicationControllerListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1ReplicationControllerListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ResourceQuota. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ResourceQuotaListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/resourcequotas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ResourceQuota. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ResourceQuotaListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1ResourceQuotaListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Secret. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1SecretListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/secrets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Secret. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1SecretListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1SecretListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ServiceAccount. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ServiceAccountListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/serviceaccounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ServiceAccount. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ServiceAccountListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1ServiceAccountListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Service. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ServiceListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/api/v1/watch/services`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Service. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchCoreV1ServiceListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchCoreV1ServiceListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
